export default {
      id: "ic_mp-usage",
      viewBox: "0 0 25 20",
      url: "/" + "images/icons.3.109.2.svg#ic_mp-usage",
      toString: function () {
        return this.url;
      }
    }